import {r as register, l as load} from '@theme/theme-sections';
import {loadCarouselDependencies} from '@theme/carousel-dependencies';
import {observeSectionVisibility} from '@theme/section-visibility';
import {createSectionAutoplay} from '@theme/section-autoplay';

const sectionType = 'trust-icons';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};

if (!registeredSections[sectionType]) {
  register(sectionType, {
    onLoad() {
      this.onUnload();
      this.active = true;
      this.sliderElement = this.container.querySelector('[data-slider]');
      if (!this.sliderElement) return;
      this.intentController = new AbortController();
      const signal = this.intentController.signal;
      const demand = () => this.initializeCarousel({force: true});
      this.container.addEventListener('focusin', demand, {signal});
      this.container.addEventListener('pointerdown', demand, {signal, passive: true});
      this.stopObservingVisibility = observeSectionVisibility(this.container, (visible) => {
        this.sectionVisible = visible;
        if (visible) this.initializeCarousel();
        this.autoplay?.setVisible(visible);
      });
    },
    initializeCarousel({force = false} = {}) {
      if (!this.active || !this.container.isConnected || this.flickity || !this.sliderElement) return;
      if (this.pendingLoad) {
        this.pendingLoad.force ||= force;
        return this.pendingLoad.promise;
      }
      const request = {force};
      this.pendingLoad = request;
      request.promise = loadCarouselDependencies({fade: true}).then(({Flickity}) => {
        if (this.pendingLoad !== request || !this.active || !this.container.isConnected) return;
        if (!request.force && !this.sectionVisible) return;
        this.flickity = new Flickity(this.sliderElement, {
          prevNextButtons: false,
          autoPlay: false,
          pageDots: true,
          adaptiveHeight: false,
          fade: true,
          watchCSS: true,
        });
        this.autoplay = createSectionAutoplay(this.flickity, {
          interval: this.container.dataset.autoplay === 'true' ? Number(this.container.dataset.autoplaySpeed) : false,
        });
        this.autoplay.setVisible(Boolean(this.sectionVisible));
        this.autoplay.setEditorPaused(Boolean(this.editorPaused));
        if (this.selectedBlock != null) this.flickity.select(this.selectedBlock);
        this.selectedBlock = null;
      }).catch(error => {
        if (this.pendingLoad === request && this.active) console.warn('Could not load trust carousel:', error);
      }).finally(() => {
        if (this.pendingLoad === request) this.pendingLoad = null;
      });
      return request.promise;
    },
    onSelect() {
      if (!window.Shopify?.designMode) return;
      this.editorPaused = true;
      this.initializeCarousel({force: true});
      this.autoplay?.setEditorPaused(true);
    },
    onBlockSelect(event) {
      if (!window.Shopify?.designMode) return;
      const slide = event.target.closest?.('.trust-icons__slide');
      const index = Array.from(this.container.querySelectorAll('.trust-icons__slide')).indexOf(slide);
      if (index < 0) return;
      this.selectedBlock = index;
      this.onSelect();
      this.flickity?.select(index);
    },
    onBlockDeselect() {
      this.onDeselect();
    },
    onDeselect() {
      if (!window.Shopify?.designMode) return;
      this.editorPaused = false;
      this.autoplay?.setEditorPaused(false);
    },
    onUnload() {
      this.active = false;
      this.pendingLoad = null;
      this.intentController?.abort();
      this.intentController = null;
      this.stopObservingVisibility?.();
      this.stopObservingVisibility = null;
      this.autoplay?.destroy();
      this.autoplay = null;
      this.flickity?.destroy();
      this.flickity = null;
      this.sliderElement = null;
      this.sectionVisible = false;
      this.editorPaused = false;
      this.selectedBlock = null;
    },
  });
}
load(sectionType);
